import { MainInner } from "@/styles/global";
import { PrimaryButtonCss } from "@/styles/typography";
import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";

const Inner = styled(MainInner)`
  aspect-ratio: 4 / 2;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    height: 500px;
  }
`;

const BackgroundImage = styled(GatsbyImage)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
  aspect-ratio: 9/16;
  max-height: 544px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    height: 491px;
    aspect-ratio: 16/9;
  }
`;

const VideoContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }

  &::before {
    content: "";
    position: absolute;
    background: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
  }
`;

const Button = styled.button`
  z-index: 3;
  position: absolute;
  bottom: 13px;
  right: 32px;
  ${PrimaryButtonCss}
  gap: 10px;

  svg {
    margin-bottom: 2px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    right: 116px;
  }
`;

const S = {
  VideoContainer,
  BackgroundImage,
  Inner,
  Button,
};

export default S;
